(function($, $doc) {
	(function($) {
		var instance = 0, instances = [], Class;

		Class = function($shell, settings) {
			var my, cls;

			cls = {
				start: function() {
					return my.start.apply($shell, arguments);
				}
			};

			my = {
				enable: function() {
					if ($shell.data("wscounter-active")) {
						return $shell;
					}

					settings = $.extend({
						'thousands_separator': ',',
						'animation': {
							'min_duration': 5000
						},
						'start': 0
					}, settings || {});

					my.ui = {
						'$animate': $({
							'time': 0
						})
					};

					my.status = {
						'start': settings.start,
						'current': settings.start,
						'finish': parseFloat(($shell.html() || '').replace(/[^\d]/, ""))
					};
				},

				start: function(after) {
					var duration;

					duration = settings.animation.duration;

					duration = (my.status.finish / 50);

					if (duration < settings.animation.min_duration) {
						duration = settings.animation.min_duration;
					}

					// start counting
					my.ui.$animate.animate({
						'time': 1
					}, {
						'duration': (duration * .2),
						'step': function(now) {
							if ((my.status.finish - my.status.current) <= 100) {
								my.ui.$animate.stop();

								my.ui.$animate.animate({
									'time': 1
								}, {
									'duration': (duration - (duration * .2)),
									'step': function(now) {
										my.status.current = Math.ceil(my.status.finish * now);
										$shell.html(my.status.current.toFormatted(0));
									},
									'complete': function() {
										if (typeof after === "function") {
											after.apply($shell);
										}
									}
								});
							} else {
								my.status.current = Math.ceil(my.status.finish * now);
							}

							$shell.html(my.status.current.toFormatted(0));
						}
					});
				}
			};

			my.enable();

			return cls;
		};

		$.fn.WSCounter = function() {
			var a, $this, args;

			args = arguments;

			this.each(function() {
				$this = $(this);

				if ((a = $this.data("wscounter-instance")) === undefined) {
					$this.data("wscounter-instance", instance);
					a = instance;
					instance = instance + 1;
				}

				if (typeof args[0] === "string") {
					if (instances[a] && instances[a][args[0]]) {
						instances[a][args[0]].apply($this, Array.prototype.slice.call(args, [1]));
					} else {
						throw new Error("Instance must be created before methods are used");
					}
				} else {
					instances.push(new Class($this, args[0]));
				}
			});

			return this;
		};
	}($));

}(window.jQuery, window.jQuery(document.body)));
